import { result } from 'underscore';
import React from 'react';
import { withRouter } from '@bingads-webui-campaign-react/router';
import {
  withSiteMap,
  processor,
  findDeepSiteMap,
  siteMapPropType,
} from '@bingads-webui-campaign-react/with-site-map';

const ApexUpdaterInternal = ({ siteMap }) => {
  let apexViewName = '';
  if (window.ApexPlatform) {
    const currentPage = findDeepSiteMap(siteMap, node => node.selected);
    if (currentPage) {
      // take apexViewName for apex, if not exist, take all route sections as apexViewName
      apexViewName = currentPage.apexViewName || result(currentPage, 'route', '').replace(/\//g, '_');

      window.ApexPlatform.Refresh(apexViewName);
    } else {
      window.ApexPlatform.Refresh();
    }
  }
  return (
    <div
      railviewId={apexViewName}
      style={{ display: 'none' }}
    />
  );
};

ApexUpdaterInternal.propTypes = {
  siteMap: siteMapPropType.isRequired,
};

export const ApexUpdater = withRouter(withSiteMap(React.memo(ApexUpdaterInternal), [processor.processPermissions, processor.processPath]));
